// NPC dialog's speech bubbles (qa-runs#1167): a bubble over the speaking token, with its name as this person heard it,
// for about a second per five words (3 to 10 s); a click or a tap dismisses it; each token shows its newest line. Drawn
// over the canvas at the board's camera, like the map pins. A bubble comes only with a line the server sent this person
// with its token — a token they could not see sent none — and only for a token on the scene this screen shows.
import { useEffect, useState } from 'react';
import { useTableState } from '../table/TableState';
import { dialogs, useDialog } from '../dialog';
import { boardBus, type BoardViewState } from './bus';

function useView(): BoardViewState | null {
  const [v, setV] = useState<BoardViewState | null>(null);
  useEffect(() => boardBus.onView(setV), []);
  return v;
}

export function DialogueBubbles() {
  const { store } = useTableState();
  const { bubbles } = useDialog();
  const view = useView();
  if (!view || !(view.view.zoom > 0)) return null;
  const z = view.view.zoom;
  return (
    <>
      {Object.entries(bubbles).map(([id, b]) => {
        const o = store.state.objects[id];
        if (!o) return null;
        const sx = (o.x - view.view.x) * z;
        const sy = (o.y - view.view.y - 35 * (o.size?.h ?? 1)) * z;
        if (sx < -200 || sy < -200 || sx > view.viewport.width + 200 || sy > view.viewport.height + 200) return null;
        return (
          <button key={id} type="button" data-testid="dialog-bubble" aria-label={`${b.line.name || 'A line'}: ${b.line.text}. Dismiss`}
            className="vtt-popover pointer-events-auto absolute max-w-[min(18rem,80vw)] -translate-x-1/2 -translate-y-full rounded-lg px-2 py-1 text-left text-sm shadow-lg"
            style={{ left: Math.max(8, Math.min(view.viewport.width - 8, sx)), top: Math.max(8, sy - 6), touchAction: 'manipulation' }}
            onPointerDown={(e) => e.stopPropagation()} onClick={() => dialogs.dismiss(id)}>
            {b.line.name && <span className="block text-xs font-semibold" data-testid="dialog-bubble-name">{b.line.name}</span>}
            <span className="block whitespace-pre-wrap break-words">{b.line.text}</span>
          </button>
        );
      })}
    </>
  );
}
